import { gql } from '@apollo/client';

export default gql`
  mutation createInvoiceEventEmployee($eventId: String, $cashin: Float) {
    createInvoiceEventEmployee(eventId: $eventId, cashin: $cashin) {
      ok
      message
      data
      error
    }
  }
`;
